import { Injectable } from '@angular/core';
import {
  DeleteTranslationResponse,
  ImportTranslationResponse,
  SaveTranslationContractData,
  SaveTranslationResponse,
  SprogLag,
  SprogLagLanguageMap,
  DeepLTranslationRequest,
  DeepLTranslationResponseItem
} from './translations.model';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpService } from 'src/app/services/http.service';
import { HttpParamsBuilder } from 'src/app/services/HttpParamsBuilder';

@Injectable({
  providedIn: 'root'
})
export class TranslationsService {

  private apiKey: string = 'AIzaSyDSS8wzA16xJdQRpiyLrKhs6TrCmu_Eq0M';
  private apiUrl: string = 'https://translation.googleapis.com/language/translate/v2';
  private cache = new Map<string, string>();
  private apiBase = `${environment.adminConfig.apiUri}/translation`;

  constructor(
    private http: HttpService,
  ) { }

  async getTranslations(feltNavn?: string, vaerdi?: string): Promise<SprogLagLanguageMap[]> {
    const builder = new HttpParamsBuilder();
    builder.append('feltNavn', feltNavn);
    builder.append('vaerdi', vaerdi);
    
    return await this.http.get<SprogLagLanguageMap[]>(this.apiBase, null, { params: builder.build() });
  }

  async saveTranslations(translations: SprogLag[]): Promise<SaveTranslationResponse | null> {
    if (translations.length === 0) return null;
    const contracts: SaveTranslationContractData[] = translations.map(translation => {
      return {
        frontendGuid: translation.frontendGuid!,
        id: translation.id,
        kundeId: translation.kundeId,
        feltNavn: translation.feltNavn,
        vaerdi: translation.vaerdi,
        cultureId: translation.cultureId
      };
    });

    return await this.http.post(`${environment.adminConfig.apiUri}/translation`, contracts);
  }

  async translateText(text: string, sourceLanguage: string | null | undefined, targetLanguage: string): Promise<string> {
    if (!text?.trim()) {
      return Promise.resolve('');
    }

    const normalizedSource = sourceLanguage?.trim() || ''; // empty => auto-detect
    const cacheKey = `${text}::${normalizedSource || 'auto'}::${targetLanguage}`;
    if (this.cache.has(cacheKey)) {
      return Promise.resolve(this.cache.get(cacheKey)!);
    }

    const url = `${this.apiBase}/deepl/translate`;
    const body: DeepLTranslationRequest = {
      text,
      targetLanguage,
      sourceLanguage: normalizedSource || undefined
    };

    const result = await this.http.post<DeepLTranslationResponseItem[], DeepLTranslationRequest>(url, body, null,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
      
    if (!Array.isArray(result) || result.length === 0) {
      throw new Error('Empty translation response');
    }
    const translated = result[0].translatedText;
    this.cache.set(cacheKey, translated);
    return translated;

  }

  async getCultureIds(): Promise<string[]> {
    return await this.http.get<any>(`${this.apiBase}/cultureIds`);
  }

  async deleteTranslation(ids: number[]): Promise<DeleteTranslationResponse> {
    return await this.http.delete(`${this.apiBase}/${ids}`);
  }

  decodeHtmlEntities(text: string): string {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
  }

  async getLatestImportDate(): Promise<Date> {
    const dateStr = await this.http.get<string>(`${this.apiBase}/importDate`);
    const date = new Date(dateStr);
    // Vi vil kun se hvilken dag de blev tilføjet. 
    date.setHours(0, 0, 0, 0);

    return date;
  }

  async getImportCount(): Promise<number> {
    return await this.http.get<number>(`${this.apiBase}/importCount`);
  }

  async getDeleteCount(): Promise<number> {
    return await this.http.get<number>(`${this.apiBase}/deleteCount`);
  }

  async importTranslations(): Promise<ImportTranslationResponse> {
    return await this.http.post<ImportTranslationResponse, null>(`${this.apiBase}/import`, null);
    //   return {
    //     results: [
    //         { fieldname: 'Field1', type: ImportTranslationType.Import },
    //         { fieldname: 'Field2', type: ImportTranslationType.Import },
    //         { fieldname: 'Field3', type: ImportTranslationType.Import },
    //         { fieldname: 'Field4', type: ImportTranslationType.Import },
    //         { fieldname: 'Field5', type: ImportTranslationType.Import },
    //         { fieldname: 'Field6', type: ImportTranslationType.Import },
    //         { fieldname: 'Field7', type: ImportTranslationType.Import },
    //         { fieldname: 'Field8', type: ImportTranslationType.Delete },
    //         { fieldname: 'Field9', type: ImportTranslationType.Delete },
    //         { fieldname: 'Field10', type: ImportTranslationType.Delete }
    //     ],
    //     errors: [
    //         { fieldname: 'Field11', type: ImportTranslationType.Import, message: 'Error importing Field11' },
    //         { fieldname: 'Field12', type: ImportTranslationType.Delete, message: 'Error deleting Field12' },
    //         { fieldname: 'Field13', type: ImportTranslationType.Import, message: 'Error importing Field13' },
    //         { fieldname: 'Field14', type: ImportTranslationType.Delete, message: 'Error deleting Field14' },
    //         { fieldname: 'Field15', type: ImportTranslationType.Import, message: 'Error importing Field15' }
    //     ]
    // };
  }

}
